import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Button } from 'reactstrap';

const controls = [
    { label: 'Salad', type: 'salad' },
    { label: 'Cheese', type: 'cheese' },
    { label: 'Meat', type: 'meat' },
]

const BuildControl = props => {
    return (
        <div className='d-flex' >
            <div style={{ marginRight: 'auto', fontWeight: 'bold', fontSize: '1.2rem' }} >{props.label}</div>
            <button type='button' className='btn btn-success btn-sm m-1'
                onClick={() => props.addIngredients(props.type)}
            >More</button>
            <button type='button' className='btn btn-danger btn-sm m-1'
                onClick={() => props.removeIngredients(props.type)}
            >Less </button>
        </div>
    )
}

const Controls = props => {
    return (
        <div className='container'>
            <Card style={{
                marginTop: '30px',
                marginBottom: '200px',
                textAlign: 'center'
            }}>
                <CardHeader tag='h5' style={{
                    backgroundColor: '#D70F64',
                    color: 'white',
                }}>Add Ingredients</CardHeader>
                <CardBody>
                    {
                        controls.map(item => {
                            return <BuildControl
                                label={item.label}
                                type={item.type}
                                key={item.type}
                                addIngredients={props.addIngredients}
                                removeIngredients={props.removeIngredients}
                            />
                        })
                    }
                </CardBody>
                <CardFooter tag='h5'>Price: {props.price} BDT</CardFooter>
                <Button
                    onClick={props.modalToggler}
                    disabled={props.price <= 80}
                    style={{ backgroundColor: '#D70F64' }}
                >Order Now</Button>
            </Card>
        </div>
    )
}

export default Controls;